import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Behavioral Health of Delaware theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const BHOFDE_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/bhofde/logo.png",
        alt: "Behavioral Health of Delaware Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 34,
  state: "DE",
  departmentIds: [173],
};
